import React from 'react';
import { Container } from 'react-bootstrap';
import './ClientsSection.css';

const logoUrls = [
  "https://dazbog.ascentbw.com/Images/Home/logo1.png",
  "https://dazbog.ascentbw.com/Images/Home/logo2.png",
  "https://dazbog.ascentbw.com/Images/Home/logo3.png",
  "https://dazbog.ascentbw.com/Images/Home/logo4.png",
  "https://dazbog.ascentbw.com/Images/Home/logo5.png",
  "https://dazbog.ascentbw.com/Images/Home/logo6.png",
];

const ClientsSection = () => {
  return (
    <section className="clients-section-card-wrapper">
      <Container>
        <div className="clients-card-container">
          <p className="clients-card-title">
            Trusted Across Renewable Energy Ecosystems
          </p>
          <div className="marquee-container">
            <div className="marquee-track">
              {[...logoUrls, ...logoUrls].map((url, index) => (
                <div className="marquee-item" key={index}>
                  <img 
                    src={url} 
                    alt={`Partner logo ${(index % 6) + 1}`} 
                    className="client-logo-img" 
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ClientsSection;